module.exports = __webpack_public_path__ + "static/media/giftcard_16.7aeb0711.jpg";